export default function authSession() {
  const authSession = useState("auth-session", () => ({
    username: "",
    email: "",
    password: "",
    password_confirmation: "",
    permissions: [],
    token: null,
  }));

  return { authSession };
}
